<ng-container *ngIf="isReady; else loading">
  <router-outlet></router-outlet>
</ng-container>

<ng-template #loading>
  <div class="min-h-screen flex items-center justify-center bg-surface-50">
    <div class="flex flex-col items-center gap-3">
      <div class="w-10 h-10 rounded-full border-4 border-primary-200 border-t-primary-500 animate-spin"></div>
      <p class="text-sm text-surface-500">Chargement...</p>
    </div>
  </div>
</ng-template>
